var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-label-group',{staticClass:"mb-2",attrs:{"label":_vm.calcLabel}},[_c('b-form-textarea',{ref:"field",attrs:{"value":_vm.value,"rows":_vm.rows,"disabled":_vm.disabled,"readonly":_vm.readonly,"placeholder":_vm.placeholder,"required":_vm.required,"size":"lg"},on:{"blur":function($event){return _vm.$emit('blur', _vm.innerValue)},"input":function($event){return _vm.onInput($event)}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e298cbd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisation/BCustomTextarea.vue
// module id = 1247
// module chunks = 1